import { TOKEN_KEYS } from "../auth";

/**
 * Get the original URL encoded for use as OAuth state parameter
 */
export function getOriginalEncodedUrl(): string {
  const originalUrl = globalThis.location.href;
  return encodeURIComponent(originalUrl);
}

/**
 * Set the user's primary language in session storage
 */
export function setPrimaryLanguage(languageCode: string): void {
  sessionStorage.setItem(TOKEN_KEYS.USER_PRIMARY_LANGUAGE, languageCode);
}

/**
 * Get the user's primary language from session storage
 * @returns The language code or 'en' as default
 */
export function getPrimaryLanguage(): string {
  return sessionStorage.getItem(TOKEN_KEYS.USER_PRIMARY_LANGUAGE) || "en";
}
